





















































import Component from "vue-class-component";
import DocumentInsertionBroadcastDate from "./fields/DocumentInsertionBroadcastDate.vue";
import StandardList from "front-component/components/List.vue";
import DocumentLabel from "./fields/DocumentLabel.vue";
import DocumentType from "./fields/DocumentType.vue";
import DocumentDate from "./fields/DocumentDate.vue";
import DocumentInsertionCampaign from "./fields/DocumentInsertionCampaign.vue";
import DocumentInsertionLabel from "./fields/DocumentInsertionLabel.vue";
import DocumentInsertionNumber from "./fields/DocumentInsertionNumber.vue";
import DocumentInsertionPurchaseOrder from "./fields/DocumentInsertionPurchaseOrder.vue";
import DocumentInsertionQuotationNumber from "./fields/DocumentInsertionQuotationNumber.vue";
import DocumentInsertionRequest from "./fields/DocumentInsertionRequest.vue";
import DocumentInsertionSupplier from "./fields/DocumentInsertionSupplier.vue";
import DocumentInsertionSupport from "./fields/DocumentInsertionSupport.vue";
import Http, {Data} from "front-component/Http";
import DocumentRepository from "@/repositories/insertion/DocumentRepository";
import {Prop, Watch} from "vue-property-decorator";
import _ from "lodash";
import EventBus from "front-component/EventBus";

export interface Insertion {
    broadcastStartDate: string;
    campaign: string;
    label: string;
    number: number;
    purchaseOrderNumber: string;
    quotationNumber: string;
    supplier: string;
    support: string;
    request: {
        title: string;
    };
}

export interface Document {
    uuid: string;
    type: string;
    clientOriginalFilename: string;
    createdAt: string;
    insertions: Insertion[];
}

const components = {
    DocumentLabel,
    DocumentType,
    DocumentDate,
    DocumentInsertionLabel,
    DocumentInsertionNumber,
    DocumentInsertionBroadcastDate,
    DocumentInsertionCampaign,
    DocumentInsertionSupport,
    DocumentInsertionSupplier,
    DocumentInsertionQuotationNumber,
    DocumentInsertionPurchaseOrder,
    DocumentInsertionRequest
};

@Component({ components })
export default class DocumentList extends StandardList {
    protected route: string = "get_document";
    protected fields: string[] = [];
    protected checkedAll: boolean = false;
    protected selectedDocumentUuids: {[key: string]: string} = {};
    protected elements: Document[] = [];
    protected totalDocuments: number = 0;


    @Prop( { default: "" }) public hiddenComponent !: string[];
    @Prop( { default: 50}) public limitPerPage !: number;

    @Watch("filters") public clearSelectedDocuments(): void {
        this.selectedDocumentUuids = {};
        this.checkedAll = false;
    }

    @Watch("limitPerPage") public loadExport() {
        this.page = 1;
        this.hasNextPage = true;
        this.elements = [];
        this.loadUsingApi();
    }

    @Watch("selectedDocumentUuids") public onSelectedDocumentsChange(): void {
        this.$emit("update-document-selected", _.values(this.selectedDocumentUuids));
    }

    protected get countSelectedDocuments(): number {
        return Object.keys(this.selectedDocumentUuids).length;
    }
    protected loadUsingApi(): void {
        const params: object = {
            filters: this.filters,
            orders: this.orders,
            fields: this.fields,
            pagination: {
                nb_per_page: this.limitPerPage,
                page: this.page,
            },
        };
        if (!this.loading && this.hasNextPage) {
            this.loading = true;

            Http
                .search(this.link(), params,
                    (data: Data) => {
                        this.$emit("update", data.data);
                        data.data.data.forEach((entity: any) => this.elements.push(entity));
                        this.totalDocuments = data.data.total;
                        this.hasNextPage = data.data.data.length > 0;
                        this.loading = false;
                    },
                    (error: any) => {
                        if (this.$options.filters) {
                            EventBus.$emit(
                                "error-alert",
                                { message: this.$options.filters.trans("An error occurred while loading the list.") }
                            );
                            this.loading = false;
                        }
                    }
                )
            ;
        }
    }
    public activeComponent(component: string) {
        return !_.includes(this.hiddenComponent, component);
    }

    public created(): void {
        this.fields = Http.computeStandardFields(components, "document");
    }

    public updateSelected(uuid: string, event: any): void {
        if (event.target.checked) {
            this.$set(this.selectedDocumentUuids, uuid, uuid);
        } else if (this.selectedDocumentUuids[uuid]) {
            this.$delete(this.selectedDocumentUuids, uuid);
        }
    }

    private isChecked(documentUuid: string): boolean {
        return _.has(this.selectedDocumentUuids, documentUuid);
    }

    private selectAllRows(event: any): void {
        if (event.target.checked) {
            this.elements.forEach((document: Document) => {
                this.$set(this.selectedDocumentUuids, document.uuid, document.uuid);
            });
        } else {
            this.selectedDocumentUuids = {};
        }
        this.checkedAll = event.target.checked;
    }

    protected link(): string {
        return DocumentRepository.getSearchDocumentsUrl();
    }
}
